import React, { useState, useCallback } from 'react';

const FileDropzone = ({ onFilesSelected, selectedFiles }) => {
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDragIn = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setIsDragOver(true);
    }
  }, []);

  const handleDragOut = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const filesArray = Array.from(e.dataTransfer.files);
      onFilesSelected(filesArray);
    }
  }, [onFilesSelected]);

  const handleFileInput = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const filesArray = Array.from(e.target.files);
      onFilesSelected(filesArray);
    }
  };

  const removeFile = (index) => {
    const newFiles = selectedFiles.filter((_, i) => i !== index);
    onFilesSelected(newFiles);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div>
      {/* Compact inline attach control */}
      <div
        className={`d-flex align-items-center justify-content-between gap-2 p-2 rounded mb-2 ${isDragOver ? 'border border-primary bg-primary bg-opacity-10' : 'border border-secondary bg-transparent'}`}
        onDragEnter={handleDragIn}
        onDragLeave={handleDragOut}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        style={{ minHeight: '48px' }}
      >
        <div className="d-flex align-items-center gap-2">
          <i className={`bi bi-paperclip ${isDragOver ? 'text-primary' : 'text-secondary'}`} />
          <div className="small text-muted">{isDragOver ? 'Drop files to attach' : 'Attach context files (optional)'}</div>
        </div>
        <div>
          <input
            type="file"
            id="fileInput"
            multiple
            onChange={handleFileInput}
            style={{ display: 'none' }}
          />
          <label htmlFor="fileInput" className="btn btn-sm btn-outline-primary">
            <i className="bi bi-folder2-open me-1"></i>
            Attach
          </label>
        </div>
      </div>

      {/* Selected Files shown as small badges */}
      <div>
        {selectedFiles.length > 0 ? (
          <div className="d-flex flex-wrap gap-2">
            {selectedFiles.map((file, index) => (
              <div key={index} className="badge bg-light border text-dark d-flex align-items-center" style={{ padding: '0.4rem 0.6rem' }}>
                <i className="bi bi-file-earmark me-2 text-primary"></i>
                <span className="me-2 small">{file.name}</span>
                <button type="button" className="btn-close btn-close-white btn-sm ms-1" aria-label="Remove" onClick={() => removeFile(index)} style={{ filter: 'invert(0.2)' }} />
              </div>
            ))}
          </div>
        ) : (
          <div className="small text-muted">No files selected</div>
        )}
      </div>
    </div>
  );
};

export default FileDropzone;
